import React, { Component } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/lib/Modal";
import { connect } from "react-redux";
import TicketInfo from "../ticketInfo/TicketInfo";
import {
  fetchTicketInfo,
  fetchTicketGroupInfo,
  fetchEvent,
} from "../../login/api.actions";
import {
  getNameVenueORExtra,
  arrayFunctionFilter,
  validationModes,
  getPromotionColor,
  getBuyerTypeColor,
} from "../../utils/verifier.utils";
import { FormattedMessage } from "react-intl";
import moment from "moment-timezone";

function ValidationHistoryItem(props) {
  const timeZone = JSON.parse(sessionStorage.getItem("timeZone"));
  return (
    <div onClick={props.open} className="grey-background history">
      <h2>
        {" "}
        Loc. Res: {props.validation[0].reservationId} - Loc. Entr:{" "}
        {props.validation[0].ticketId}{" "}
        <span className="pull-right">
          {moment(props.validation[0].scanDate).tz(timeZone).format("HH:mm:ss")}
        </span>
      </h2>

      <ul>
        {props.validation.map((item, index) => (
          <li
            key={index}
            style={
              getBuyerTypeColor(item.buyerTypeId) && item.resultCode === 200
                ? { color: getBuyerTypeColor(item.buyerTypeId) }
                : {}
            }
            className={
              item.resultCode === 200 || item.resultCode === 203
                ? "success"
                : "error"
            }
          >
            <p>
              <span className="icon-own-ticketVerifier" />{" "}
              {getNameVenueORExtra(item)}
              <span className="pull-right">
                {item.validationMode === validationModes.override && (
                  <span className="icon-own-forced-ticket" />
                )}
                &nbsp;
                {item.promotionId && (
                  <span
                    style={
                      getPromotionColor(item.promotionId)
                        ? { color: getPromotionColor(item.promotionId) }
                        : {}
                    }
                    className="icon-own-star"
                  />
                )}
              </span>
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
}

class History extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validations: [],
      numberOfValidations: 5,
    };
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentValidation && nextProps.currentValidation.length > 0) {
      var validations = this.state.validations;
      const limitValidations = this.state.numberOfValidations + 1;

      validations.push(nextProps.currentValidation);
      validations.length === limitValidations
        ? this.setState({ validations: validations.slice(1, limitValidations) })
        : this.setState({ validations: validations });
    }
  }

  render() {
    const { validations } = this.state;

    const listValidationItems = validations.map((validation) => (
      <ValidationHistoryItem
        key={"T" + validation[0].ticketId + validation[0].scanDate}
        validation={validation}
        open={() => this.openModal(validation)}
      />
    ));

    const { showModal, ticketInfo, validation } = this.state;

    return (
      <div>
        <div>
          <h1>
            <FormattedMessage
              id="title.scanned.tickets"
              defaultMessage="Entradas Escaneadas"
            />
          </h1>
          <div>{listValidationItems.reverse()}</div>
        </div>

        <Modal
          show={showModal}
          onHide={this.closeModal}
          bsSize="large"
          dialogClassName="modal-ticket-info"
        >
          <TicketInfo ticketInfo={ticketInfo} validation={validation} />
        </Modal>
      </div>
    );
  }

  checkEvents(ticketInfo) {
    const { dispatch } = this.props;

    ticketInfo.forEach((ticketInfo) => {
      let object = arrayFunctionFilter("events", ticketInfo.eventId, "eventId");
      let events = JSON.parse(sessionStorage.getItem("events"));
      if (object === undefined || object === null) {
        dispatch(fetchEvent(ticketInfo.eventId)).then(({ response }) => {
          events.push(response);

          sessionStorage.setItem("events", JSON.stringify(events));
        });

        console.log("Event Added");
      }
    });
  }

  handlerGetTicketInfo(ticketId, isTicketGroup, validation) {
    const { dispatch } = this.props;
    this.setState({
      ticketInfo: {},
    });

    if (isTicketGroup === undefined) isTicketGroup = false;

    if (validation[0].barcode) {
      ticketId = validation[0].barcode;
    }

    isTicketGroup
      ? dispatch(fetchTicketGroupInfo(ticketId)).then(({ response }) => {
          this.checkEvents(response);
          //then
          setTimeout(() => {
            this.setState({
              ticketInfo: response,
            });
          }, 500);
        })
      : dispatch(fetchTicketInfo(ticketId)).then(({ response }) => {
          this.checkEvents(response);
          //then
          setTimeout(() => {
            this.setState({
              ticketInfo: response,
            });
          }, 500);
        });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal(validation) {
    this.handlerGetTicketInfo(
      validation[0].ticketId,
      validation[0].ticketGroup,
      validation
    );
    this.setState({
      showModal: true,
      validation: validation,
    });
  }
}

History.propTypes = {
  currentValidation: PropTypes.array,
};

export default connect()(History);
